var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffshoreBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66667 15.6667V34M5.66667 34H17M5.66667 34H2M12.3333 22.3333V27.3333M19 22.3333V27.3333M4 15.6667H34M4 10.6667L19 4L34 10.6667",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 33C46 39.0751 41.0751 44 35 44M46 33C46 26.9249 41.0751 22 35 22M46 33H24M35 44C28.9249 44 24 39.0751 24 33M35 44C37.025 44 38.6667 39.0751 38.6667 33C38.6667 26.9249 37.025 22 35 22M35 44C32.975 44 31.3333 39.0751 31.3333 33C31.3333 26.9249 32.975 22 35 22M24 33C24 26.9249 28.9249 22 35 22",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffshoreBank);
export default __webpack_public_path__ + "static/media/offshoreBank.5a5b2f455501383f95db61ecd1887ef7.svg";
export { ForwardRef as ReactComponent };